import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { VARIANTES } from '../../data/variantes';
import type { VarianteAnuncio } from '../../types';
import './HeroVariante.css';

/* Lee el parámetro ?t= de la URL y devuelve la variante si corresponde a esta
   página. Se comprueba el área para que un enlace mal configurado —por ejemplo
   ?t=divorcio en la página laboral— no muestre un titular ajeno: en ese caso
   cae al texto general, que siempre es correcto. */
export function useVarianteAnuncio(area: VarianteAnuncio['area']): VarianteAnuncio | null {
  const [params] = useSearchParams();
  const clave = params.get('t');
  if (!clave) return null;
  const v = VARIANTES[clave];
  return v && v.area === area ? v : null;
}

/* Bloque de portada para tráfico de anuncios: nombra el problema en las
   palabras de quien buscó, entrega algo útil en la primera línea y muestra el
   plazo cuando existe. */
const HeroVariante: React.FC<{ v: VarianteAnuncio }> = ({ v }) => (
  <>
    <div className="dl-hero-label">Abogadas en Concepción</div>
    <h1 className="dl-hero-title">{v.titulo}</h1>
    <p className="dl-hero-desc">
      {v.bajada}
      {v.plazo && <> <strong className="hv-plazo">{v.plazo}</strong></>}
    </p>
    <ul className="hv-chips">
      {v.chips.map((c) => (
        <li className="hv-chip" key={c}>{c}</li>
      ))}
    </ul>
  </>
);

export default HeroVariante;
